import React, {
  useEffect,
  useState,
  useMemo,
  useRef,
  useCallback
} from "react";
import {
  Button,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  FormGroup,
  Label,
  Col,
  Alert
} from "reactstrap";
import DPlusButtonAdd from "../../../core/component/buttons/add-button/DPlusButtonAdd";
import { useDispatch, useSelector } from "react-redux";
import { getDigDaysByUserId } from "../../../redux/slices/DigDaysSlice";
import {
  convertDateToLocalTime,
  notify
} from "../../../assets/utils/UtilsFunctons";
import Select from "react-select";
import DigDayInfosCard from "../../digDays/DigDayInfosCard";
import PepDataService from "../../../services/PepDataService";
import PropTypes from "prop-types";

const PepAttachDigDayModal = ({
  selectedPep,
  onDataReload,
  currentPageIndex
}) => {
  const dispatch = useDispatch();
  const { digDaysByUserId } = useSelector((state) => ({ ...state.digDays }));
  const [modal, setModal] = useState(false);
  const [selectedDigDay, setSelectedDigday] = useState(undefined);
  const [isAttaching, setIsAttaching] = useState(false);

  const isMounted = useRef(true);

  useEffect(() => {
    isMounted.current = true;
    return () => {
      isMounted.current = false;
    };
  }, []);

  const availableDigDaysForAttach = useMemo(() => {
    let options = [];
    if (digDaysByUserId && digDaysByUserId?.data && selectedPep) {
      digDaysByUserId?.data?.map((digDay) => {
        if (
          digDay.state != 5 &&
          digDay.digDayId &&
          !selectedPep.digDayIds?.includes(digDay.digDayId)
        ) {
          // state annulé == 5
          let title =
            digDay.title + " - " + convertDateToLocalTime(digDay.date);
          options.push({ value: digDay.digDayId, label: title });
        }
      });
    }
    return options;
  }, [digDaysByUserId, selectedPep]);

  useEffect(() => {
    if (selectedPep) {
      dispatch(getDigDaysByUserId(selectedPep?.userId));
    }
  }, [selectedPep?.userId, dispatch]);

  const toggle = () => setModal(!modal);

  const handleSubmit = useCallback(async () => {
    if (selectedPep && selectedDigDay) {
      const payload = [
        {
          op: "replace",
          path: "/digDayIds",
          value: [...selectedPep?.digDayIds, selectedDigDay]
        }
      ];
      try {
        setIsAttaching(true);
        await PepDataService.editPepAction(selectedPep.id, payload);
        notify(1, "DigDay rattaché avec succès !");

        await new Promise((resolve) => setTimeout(resolve, 300));

        if (isMounted.current) {
          toggle();
          onDataReload(currentPageIndex);
        }
      } catch (error) {
        notify(0, error?.response?.data?.title ?? "Une erreur est survenue");
      } finally {
        if (isMounted.current) {
          setIsAttaching(false);
        }
      }
    }
  }, [selectedPep, selectedDigDay, isMounted, currentPageIndex]);

  return (
    <div>
      <DPlusButtonAdd
        title="Attacher"
        handleClick={toggle}
        icon={"bx bx-link"}
      />
      <Modal isOpen={modal} toggle={toggle}>
        <ModalHeader toggle={toggle}>
          {selectedPep?.userFullName} - {selectedPep?.title}
        </ModalHeader>
        <ModalBody>
          <FormGroup
            row
            className="align-item-center "
            style={{ minWidth: "350px", zIndex: "2500 !important" }}>
            <Label sm={3}>historique</Label>
            <Col sm={9} style={{ zIndex: "2500 !important" }}>
              <Select
                onChange={(e) => setSelectedDigday(e?.value)}
                placeholder="Choisir un digDay"
                options={availableDigDaysForAttach}
              />
            </Col>
            {availableDigDaysForAttach.length === 0 && (
              <Alert color={"warning"} className=" mt-3 mx-2 w-50">
                Aucun digDay disponible !
              </Alert>
            )}
          </FormGroup>
          {selectedDigDay && (
            <div
              className="list-group d-grid gap-2 border-0 w-auto p-2 "
              style={{
                maxHeight: "500px",
                overflowY: "auto",
                overflowX: "hidden"
              }}>
              <DigDayInfosCard
                digDay={digDaysByUserId?.data?.find(
                  (dd) => dd.digDayId === selectedDigDay
                )}
                fullSize={true}
              />
            </div>
          )}
        </ModalBody>
        <ModalFooter>
          <Button color="secondary" onClick={toggle}>
            Annuler
          </Button>
          <Button
            color="primary"
            onClick={handleSubmit}
            disabled={isAttaching || !selectedDigDay}>
            {isAttaching && (
              <i className="bx bx-loader-alt bx-spin bx-rotate-90" />
            )}{" "}
            Rattacher
          </Button>
        </ModalFooter>
      </Modal>
    </div>
  );
};

PepAttachDigDayModal.propTypes = {
  selectedPep: PropTypes.object,
  onDataReload: PropTypes.func,
  currentPageIndex: PropTypes.number
};

export default PepAttachDigDayModal;
